import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';

const MapPreview = (props) => {

    const setCoordinates = (mapProps,map, e) => {
        if(props.edit && !props.delete){
            props.setLocation({
                x: e.latLng.lat().toString(),
                y: e.latLng.lng().toString()
            });
        }
    }
    
    return (
        <Map
            containerStyle={{position: 'relative', width: '100%', height: '12rem'}}
            style={{position: 'static', width: '100%', height: '100%'}}
            google={props.google}
            zoom={12}
            center={{lat: props.lat, lng: props.lng}}
            onClick={setCoordinates}
            initialCenter={{lat: 14.598914950, lng: -90.50600514652838}}>
            <Marker name='Hola Mundo' position={{ lat: props.lat, lng: props.lng }}/>
        </Map>
    );
}

export default GoogleApiWrapper({
    apiKey: 'AIzaSyD5JAXCz6BN6appDX3agzwFy5WeuUcLFy0'
})(MapPreview);